module.exports = __webpack_public_path__ + "img/rule.764f502f.png";